export default {
  inject: ['i18n'],
  props: {
    model: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    onChange: {
      type: Function,
      default: function _default() {}
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  }
};